import { Error } from '../../types/error'

export type EskatConsentState = Partial<ConsentRequestDto>

export interface ConsentRequestDto {
	consentRequest: string
	environment: EskatApiEnvironment
}

export type EskatSessionDto = {
	sessionId: string
	dataReceivedOn?: Date
	customEndpointFailure?: boolean
	finishedOn?: Date
}

export enum EskatApiEnvironment {
	Production = 'production',
	Demo = 'demo',
	Mock = 'mock',
}

export enum EskatDataFetchingStatusEnum {
	IDLE = 'idle',
	FETCHING = 'fetching',
	FETCH_FAILURE = 'fetchFailure',
	FETCH_SUCCESS = 'fetchSuccess',
}

export interface EskatDataFetchingState {
	status: EskatDataFetchingStatusEnum
	error?: Error
}

//api
export interface ApplicantDto {
	id: string
	caseId: string
	clientId: number
	consumerId?: string
	consumerEmail?: string
	hashedConsumerCpr?: string
	consumerPhone?: string
	consumerInputJson?: string
	invitationSentOn?: string
	authenticatedOn?: string
	finishedOn?: string
	deletedOn?: string
	finishedSessionId?: string
	consentAcceptedOn?: string
}

export interface ApplicantSessionDto {
	id: string
	clientId: number
	applicantId?: string
	authenticatedOn?: string
	finishedOn?: string
	consumerInputJson?: string
	budgetEstimatesJson?: string
	budgetCorrectedEstimatesJson?: string
	debtOverviewEstimatesJson?: string
	debtOverviewUserCorrectedJson?: string
	deletedOn?: string
	deletedByUser?: number
	consentAcceptedOn?: string
	dataOwnedDeletedOn?: string
}

export interface ConsumerInputs {
	personalInformation?: PersonalInformation
}

export interface PersonalInformation {
	hashedCprNumber?: string
	phoneNumber?: string
	email?: string
	nationalities?: string[]
}

export interface EskatError {
	titleKey: string
	descriptionKey: string
	errorCode?: string
	errorCodeDescriptionKey?: string
}

export interface EskatCompletedEvent extends Record<string, unknown> {
	returnCode: EskatCoreStatusCode
	subErrorCode: string
	eskatErrorCode: string
	eventId: 'monthio-eskat' | 'monthio-eskat-consent'
	hashedCpr: string
}

export type EskatCoreStatusCode =
	| 'Ok'
	| 'CouldNotReadResponse'
	| 'UnknownError'
	| 'ClientRelatedIntegrationError'
	| 'EskatUnavailable'
	| 'EskatServerError'
	| 'IntegrationError'
	| 'EndUserDisabledCookies'
	| 'EndUserCancelled'
	| 'EndUserTimeout'
	| 'NemIdError'
	| 'EndUserOCESQualifiedForNemIdError'
